import React, { useEffect, useState, useRef, useCallback, useContext } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import SeleccionVariantes from './components/SeleccionVariantes';


// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css'; // estilos del módulo

import './static/css/Detalle/Detalle_v2.css'
import { GlobalContext } from "../../providers/GlobalStatesProviders";

SwiperCore.use([Navigation]);


const Detalle_v2 = ({
  apiUrlState,
  headerState,
  modificarSpinnerState,
}) => {

  const { recursosUrlState } = useContext(GlobalContext); 
  const { id } = useParams();
  const swiperRef = useRef(null);
  const [productsGroup, setProductsGroup] = useState([]);  
  const [srcImages, setSrcImages] = useState([]);

  const goToSlide = useCallback((referencia) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const index = srcImages.findIndex((img) => img.Referencia === referencia);
      if (index !== -1) {
        swiperRef.current.swiper.slideTo(index);
      }
    }
  }, [srcImages]);

  const getProduct = async () => {
    try {
      modificarSpinnerState({ Desplegar: true, Texto: 'Cargando producto...'});
      const url = `${apiUrlState}/Api/Inventario/GetProductsGroup/${id}`;
      const response = await axios.get(url);
      if (!response.data.error) {
        setProductsGroup(response.data.data);
      }      
    } catch (error) {
      alert('Error consultando producto, intente nuevamente');
    } finally {
      modificarSpinnerState({ Desplegar: false, Texto: ''});
    }
  }

  const verifyImages = () => {
    const verifications = ['', '1', '2', '3'];
    const promises = productsGroup.map((product, indexP) =>
      verifications.map((validate, indexV) => {
        return new Promise((resolve) => {
          const url = `${recursosUrlState}/img/Productos/Ref ${product.Referencia}${validate}.webp`;
          const img = new Image();
          img.src = url;
  
          img.onload = () => resolve({ Referencia: `${product.Referencia}${validate}`, IndexKey: indexP + indexV  });
          img.onerror = () => resolve(null); // Si falla, resolvemos con null
        });
      })
    );  
    // Aplanar las promesas y esperar a que todas terminen
    Promise.all(promises.flat()).then((results) => {
      const filteredImages = results.filter((img) => img !== null); // Filtrar las imágenes válidas
      setSrcImages(filteredImages); // Actualizar el estado una vez
    });
  };
  
  useEffect(() => {
    if (productsGroup.length > 0) {
      verifyImages();
    }
  }, [productsGroup]);

  useEffect(() => {
    getProduct();
  }, [])

  return (
    <div className='detail'>
      <div className='content-detail'>

        <div className='column-one'>
          <div className='slide-carousel'>
          {
            srcImages.map((variant) => (
              <img
                key={`side-${variant.Referencia}`}
                style={{width: '80px', border: '1px solid gray', cursor: 'pointer'}}
                src={`${recursosUrlState}/img/Productos/Ref%20${variant.Referencia}.webp`}
                alt={variant.Referencia}
                onError={(e) => e.target.src = `${recursosUrlState}/img/General/base2.png`}
                onClick={() => goToSlide(variant.Referencia)}
              />
            ))
          }
          </div>
          <div>
            <Swiper
              ref={swiperRef}
              className='mySwiper'
              navigation={true}
              slidesPerView={1}
            >
            {
              srcImages.map(variant => (
                <SwiperSlide key={`slide-${variant.Referencia}`}>
                  <img
                    src={`${recursosUrlState}/img/Productos/Ref%20${variant.Referencia}.webp`}
                    alt={variant.Referencia}
                    onError={(e) => e.target.src = `${recursosUrlState}/img/General/base2.png`}
                  />
                </SwiperSlide>
              ))
            }
            </Swiper>
          </div>
        </div>

        <div className='column-two'>
          <h2 className='title'>{productsGroup[0]?.Nombre}</h2>
          {
            headerState.Cliente === 'Mayoristas' ? (
              <h6 style={{fontWeight: 'bold', fontSize:'larger'}}>
                ${productsGroup[0]?.PrecioMayorista}
              </h6>
            ) : (
              <h6 style={{fontWeight: 'bold', fontSize:'larger'}}>
                ${productsGroup[0]?.PrecioMinorista}
              </h6>
            )
          }
          <hr />
          <SeleccionVariantes
            productsGroup={productsGroup}
            recursosUrlState={recursosUrlState}
            goToSlide={goToSlide}
          />
          <hr />
          <div className='accordion' id='accordionExample'>
            <div className=''>
              <div className='' id='headingOne'
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'rgb(235, 235, 235)'}}>
                <h6
                  style={{ marginLeft: '20px', fontWeight: 'bold' }}
                  className='mb-0'>
                  Mas información
                </h6>
                <button
                  style={{padding: '10px', backgroundColor: 'black', color: 'white', fontWeight: 'bold', fontSize: 'larger'}}
                  data-toggle='collapse' data-target='#collapseOne' aria-expanded='true' aria-controls='collapseOne'>
                  &nbsp;+&nbsp;
                </button>
              </div>

              <div
                id='collapseOne' className='collapse' aria-labelledby='headingOne' data-parent='#accordionExample'
                style={{ border: '1px solid rgb(235, 235, 235)' }}
              >
                <div className='card-body'>
                  <figure style={{ padding: '10px' }}>
                    <img
                      style={{width: '95%'}}
                      src={`${recursosUrlState}/img/Medidas/medidas${productsGroup[0]?.Categoria.Categoria}.webp`}
                      alt={`Medidas`}
                      onError={(e) => e.target.src = `${recursosUrlState}/img/Medidas/medidasGeneral.webp`}
                    />
                  </figure>
                  <p>
                    <strong>Cuidados especiales: </strong>
                    Lavar en lavadora con agua fria 30ºC, ciclo delicado con colores similares, lavar con jabón suave, no exprimir.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ margin: '20px 0' }}>
            <figure style={{display: 'flex', alignItems: 'center'}}>
              <img
                style={{ width: '50px', borderRight: '3px solid black', padding: '0 5px' }}
                src={`${recursosUrlState}/img/Index/web/home/compra%20segura.png`}
                alt='Compra protegida'
              />
              <figcaption style={{ fontSize: 'larger', fontWeight: '400', marginLeft: '10px' }}>
                Compra protegida
              </figcaption>
            </figure>

            <figure style={{display: 'flex', alignItems: 'center'}}>
              <img
                style={{ width: '50px', borderRight: '3px solid black', padding: '0 5px' }}
                src={`${recursosUrlState}/img/Modal/pin-negro.webp`}
                alt='Compra protegida'
              />
              <figcaption style={{ fontSize: 'larger', fontWeight: '400', marginLeft: '10px' }}>
                Disponible pago contra entrega
              </figcaption>
            </figure>
          </div>

        </div>

      </div>
    </div>
  );
}

export default Detalle_v2